<template>
  <section>
    <!-- HERO -->
    <div id="home" class="parallax">
      <div class="container">
        <h1 class="text-center"> QUIERO REGISTRAR <span class="h1-color">MI MARCA.COM </span></h1>
      <br> <h4><p  class="text-center display color-d" style="font-size:130%;font-weight: 700;">
           Haz que tu marca trabaje para ti, ¡Regístrala! ®
        </p></h4>
       <br> <h2><p class="text-center display">
        Honradez, Responsabilidad y Puntualidad
        </p></h2>
        <!--
        <router-link
          class="btn btn-leer"
          to="/solicitud"
          @click.native="scroll"
          >"Registra tu marca ahora"</router-link
        >
        -->
        <a href="./QRM/solicitud" class="btn btn-leer">"Registra tu marca ahora"</a>
        <!-- <a href="#servicios" class="btn btn-leer">Leer más </a> -->
      </div>
    </div>

    <!-- SERVICIOS -->
    <div id="servicios">
      <div class="container">
        <h2 class="subtitle">SERVICIOS</h2>
        <hr class="divider" />
        <div class="row align-items-center bgr-c">
          <div class="col-md-4 text-center my-3">
            <i class="icons fa-6x far fa-check-circle"></i>
          </div>
          <div class="col-md-8 text-center text-md-left my-3">
            <div class= "text_line" >
              <h4 class= "line">Dictamen de Viabilidad</h4>
            </div>
            <p class="text-justify">
              Llena el formato con tus datos, realiza tu pago en línea y
              nosotros te enviaremos tu dictamen con la respuesta a tu
              solicitud, así como los pasos a seguir.
            </p>
          </div>
        </div>
        <div class="divide-cl"><br></div>
        <div
          class="row align-items-center flex-column-reverse flex-md-row bgr-c"
        >
          <div class="col-md-8 text-center text-md-right my-3">
            <div class= "text_line" >
              <h4 class= "line">Registro de Marca</h4>
            </div>
            <p class="text-justify">
              Es el activo más importante de tu empresa, te ayuda a diferenciar
              productos y servicios de tus competidores. Su registro te dará el
              derecho al uso exclusivo en el territorio nacional.
            </p>
          </div>
          <div class="col-md-4 my-3 text-center">
            <i class="icons far fa-6x fa-registered"></i>
          </div>
        </div>
        <div class="divide-cl"><br></div>
        <div class="row align-items-center  bgr-c">
          <div class="col-md-4 my-3 text-center">
            <i class="icons far fa-6x fa-copyright"></i>
          </div>
          <div class="col-md-8 my-3 text-center text-md-left">
            <div class= "text_line" >
              <h4 class= "line">Registro de Aviso Comercial (Slogan)</h4>
            </div>
            <p class="text-justify">
              Es la frase que distinguirá tus productos o servicios de otros
              existentes en el mercado.
            </p>
          </div>
        </div>
        <div class="divide-cl"><br></div>

          <div
            class="row justify-content-center flex-column-reverse flex-md-row bgr-c"
          >
            <div class="col-md-8 text-center text-md-right my-3">
              <div class= "text_line" >
                <h4 class= "line">Vigilancia de Marca</h4>
              </div>
              <p class="text-justify">
                Este servicio sirve para monitorear tu Marca y/o Aviso comercial una vez obtenido su registro,
                 con la finalidad de mantener la exclusividad y evitar que la competencia registre una marca
                 igual o semejante a la tuya.
              </p>
            </div>
            <div class="col-md-4 text-center my-3">
              <i class="icons fas fa-6x fa-shield-alt"></i>
            </div>
          </div>
          <div class="divide-cl"></div>


      </div>
    </div>

    <!-- PROPIEDAD INTELECTUAL -->
    <div id="propiedad-intelectual">
      <div class="container">
        <h2 class="subtitle">Propiedad intelectual</h2>
        <hr class="divider" />
        <div class="row align-items-center">
          <div class="col-md-12">
            <img
              class="img-fluid img-galeria"
              :src="getImage('galeria/intelectual.png')"
              alt="infografía sobre la propiedad intelectual"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- ASESORAMIENTO -->
    <div id="asesoramiento" class="parallax">
      <div class="container">
        <!-- <h3>Te asesoramos de inicio a fin en el proceso de registro de tu marca de manera simple y accesible</h3> -->
        <h3>
          Registramos tu marca o aviso comercial (slogan) con unos sencillos
          datos
        </h3>
        <br />
        <ol class="text-justify" type="1">
          <!-- <router-link class="h1-color" :to="'/'" v-scroll-to="opcion.href">{{ opcion.texto.toUpperCase() }}</router-link> -->
          <li>
            Elige tu
            <router-link class="h1-color" to="/" v-scroll-to="'#paquetes'"
              >paquete</router-link
            >.
          </li>
          <li>Realiza el pago en línea.</li>
          <li>
            Estaremos al pendiente de cada etapa de tu trámite solicitado, con
            tus claves de acceso podrás revisar el avance.
          </li>
        </ol>
        <p>
          Una vez que el IMPI otorgue el registro, te enviaremos el título de
          tu marca hasta la puerta de tu casa u oficina.
          <br />
          <strong>Envío gratis a toda la república mexicana.</strong>
        </p>
        <!-- <a href="#paquetes" class="btn btn-asesoramiento">SOLICITAR PAQUETES</a> -->
        <!--
        <router-link class="btn btn-asesoramiento"  @click.native="scroll" to="/solicitud"
          >SOLICITAR MI PAQUETE</router-link
        >
        -->
        <a href="./QRM/solicitud" class="btn btn-asesoramiento">SOLICITAR MI PAQUETE</a>
        <router-link
          class="btn btn-asesoramiento"
          to="/"
          v-scroll-to="'#contacto'"
          >CONTACTO Y ASESORÍA PERSONALIZADA</router-link
        >
        <!-- <a href="#contacto" class="btn btn-asesoramiento"
          >CONTACTO Y ASESORÍA PERSONALIZADA</a
        > -->
      </div>
    </div>

    <!-- PAQUETES -->
    <div id="paquetes" class="">
      <div class="container">
        <h2 class="subtitle">Paquetes</h2>
        <hr class="divider" />

        <div class="columnas-3">
          <div class="col-lg-4 card-paquete mt-4 mb-4 tpaquete">
            <h5 class="paquete-titulo">Dictamen</h5>
            <div class="paquete-body">
              <p class="font-weight-bold">Dictamen de viabilidad</p>
              <p>
                    Examinaremos la disponibilidad para obtener el registro de tu
                    marca o aviso comercial (Slogan), evitando que sea similar a
                    otras ya existentes.
              </p>
              <hr class="divider" />
              <p class="font-weight-bold">Incluye:</p>
              <ul>
                <li>Informe de búsqueda fonética y/o figurativa.</li>
                <li>Asesoría personalizada.</li>
                <li>
                  Recibe vía correo electrónico, el examen de viabilidad con tu
                  tabla de probabilidades de registro.
                </li>
              </ul>
            </div>
            <div class="paquete-footer text-center">
              <p class="precio">costo <span>$1,000 MXN</span></p>
            </div>
          </div>
          <div class="col-lg-4 card-paquete mt-4 mb-4 tpaquete">
            <h5 class="paquete-titulo">Registro Nacional</h5>
            <div class="paquete-body">
              <p class="card-text font-weight-bold">
                Registro de marca o aviso comercial (slogan) Nacional
              </p>
              <p class="card-text">
                    Presentamos tu solicitud de marca o aviso comercial (Slogan)
                    ante el IMPI, te enviamos el acuse respectivo y le damos
                    seguimiento a tu trámite.
              </p>
              <hr class="divider" />
              <p class="card-text font-weight-bold">Incluye:</p>
              <ul>
                <li>Dictamen de viabilidad.</li>
                <li>Presentación de solicitud nacional.</li>
                <li>Asesoría personalizada.</li>
                <li>Seguimiento a tu trámite.</li>
                <li>Reporte de avances.</li>
                <li>
                  Entrega de certificado digital y a domicilio dentro de la República Mexicana sin costo adicional.
                </li>
                <li>Entrega de stickers con el logo de tu marca.</li>
                <li>Publicación en nuestras redes sociales.</li>
                <li>Recordatorios para declaración de uso y renovación.</li>
                <li>Entrega de título promocionando tu marca en nuestro canal ”EnDirecto Radio TV".
                 <img
                    class="img-paquete"
                    :src="getImage('paquetes/image004.png')"
                    alt=""
                  />
                </li>
              </ul>
            </div>
            <div class="paquete-footer text-center">
              <p class="precio">costo <span>$13,000 MXN</span><br>(más IVA)</p>
            </div>
          </div>
          <div class="col-lg-4 card-paquete mt-4 mb-4 tpaquete">
            <h5 class="paquete-titulo ">Registro en Estados Unidos</h5>

            <div class="paquete-body">
              <p class="font-weight-bold">
                    Registro de marca o aviso comercial (slogan) Internacional
              </p>
              <p class="">
                    Presentamos correctamente la solicitud de marca o aviso
                    comercial (Slogan) con protección en territorio internacional,
                    te enviamos el acuse respectivo y le damos seguimiento a tu
                    trámite.
              </p>
              <hr class="divider" />
              <p class="font-weight-bold">Incluye:</p>
              <ul>
                <li>Dictamen de viabilidad.</li>
                <li>
                  Presentación de solicitud internacional de acuerdo al
                  Protocolo de Madrid.
                </li>
                <li>Asesoría online personalizada.</li>
                <li>Seguimiento a tu trámite.</li>
                <li>Protección de tu marca a nivel internacional.</li>
                <li>Traducción de oficios de la autoridad.</li>
                <li>Reportes de avances (inglés/español).</li>
                <li>Publicación en nuestras redes sociales.</li>
                <li>Recordatorios para declaración de uso y renovación.</li>
                <li>
                  Entrega de certificado digital promocionando tu marca en nuestro canal ”EnDirecto Radio TV".
                 <img
                    class="img-paquete img-paquete-d"
                    :src="getImage('paquetes/image004.png')"
                    alt=""
                  />
                </li>
              </ul>
            </div>
            <div class="paquete-footer text-center">
              <p class="precio">costo <span>$2,000 USD</span></p>
            </div>
          </div>


        </div>
        <br />
        <div class="row">
          <div class="col text-center">
            <!--
            <router-link class="btn btn-paquete" to="/solicitud" @click.native="scroll"
              >Solicitar mi paquete</router-link
            >
            -->
            <a href="./QRM/solicitud" class="btn btn-paquete">Solicitar mi paquete</a>
          </div>
        </div>

        <div class="row">
          <div class="col text-center pt-3">
            <a href="./QRM/instrucciones/" class="btn btn-instrucciones">Instrucciones</a>
          </div>
        </div>

        <br />
        <div class="row">
          <div class="col">
            <small class="text-muted">
              <p>En todos los casos incluímos:</p>
              <ul>
                <li>Presentamos tu solicitud en menos de 48 horas.</li>
                <li>
                  Solicita tu logo con tan solo $3,000 (tres mil pesos 00/100 MXN)
                  adicionales (se entregan tres diseños novedosos y creativos).
                </li>
                <li>
                  Te enviamos tu título de registro de marca o aviso comercial
                  (slogan) totalmente gratis. Aplica únicamente dentro de la
                  República Mexicana.
                </li>
                <li>Los importes incluyen el pago de derechos al IMPI.</li>
                <li>Los importes no incluyen IVA.</li>
              </ul>
              <p>
                El otorgamiento del registro de marca o aviso comercial
                (slogan), es facultad potestativa de la autoridad y no
                responsabilidad de “QRM, Quiero Registrar mi Marca®".
              </p>
            </small>
          </div>
        </div>
      </div>
    </div>

    <!-- SOBRE NOSOTROS -->
    <div id="sobre-nosotros">
      <div class="container">
        <h2 class="subtitle">SOBRE NOSOTROS</h2>
        <hr class="divider" />
        <img
              class="img-nosotros"
              :src="getImage('sobre-nosotros/despacho01.png')"
              alt=""
        />
        <p class="f-opacity ">
              En <i><span class="colored"> QRM – Quiero Registrar mi Marca, ®</span></i>
              encontraras abogados especializados en Propiedad Intelectual,
             <i> <span class="colored"> Haz que tu marca trabaje para ti, ¡Regístrala! ®,</span></i>
              Nuestra pasión es hacer que tu creatividad tenga un impacto real.</p>

        <img
              class="img-nosotros"
              :src="getImage('sobre-nosotros/despacho03.png')"
              alt=""
        />
        <div class="row align-items-center my-5 col-dos">
          <div class="col-dos-t text-justify">
            <div class="col-dos">
              <div class="col-dos-m">
                <h5 class="subtitle line">MISIÓN</h5>
                <p>
                  Registrar los productos y servicios en forma honesta,
                  puntual y responsable para obtener la protección de los diferentes tipos
                  de marcas de nuestros clientes.
                </p>
              </div>
              <div class="col-dos-m">
                <h5 class="subtitle line">VISIÓN</h5>
                <p>
                  Fortalecer la creatividad de nuestros clientes
                  dando certeza jurídica de sus acciones, acompañándolas en el crecimiento
                  de sus proyectos.
                </p>
              </div>
            </div>

          </div>
          <div class="col-dos-t">
            <h5 class="subtitle line">NUESTROS VALORES</h5>
            <p>
                <b>Honradez:</b> Virtud que va de la mano con la verdad,
                aún en situaciones difíciles.  <br /><br /><b>Responsabilidad:</b> Dar cumplimiento
                con eficacia a lo que nos hemos comprometido.  <br /><br /><b>Puntualidad:</b> Diligencia en
                las actividades que se nos encomiendan y ser merecedores de la confianza de nuestros clientes.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- EQUIPO -->
    <div id="equipo">
      <h2 class="subtitle">EQUIPO</h2>
      <hr class="divider" />
      <div class="presentacion">
        <div class="row align-items-center no-gutters">
          <div class="col-lg-6 my-3 my-lg-0 black">
            <img
              class="img-equipo"
              :src="getImage('equipo/2000_5e33d3b4e420a.png')"
              alt="Foto Lic. Gabriela Carreño Calva"
            />
          </div>
          <div class="col-lg-6 my-3 my-lg-0">
            <div class="info-equipo">
              <h4>Mtra. Gabriela Carreño Calva</h4>
              <hr class="sub-divider" />
              <h6 class="rol">Socia Fundadora</h6>
              <p class="text-justify">
                Socia Directora en Grupo HerCar, CEO de Hernández Carreño
                Abogados (firma especializada en derecho corporativo y propiedad
                intelectual), Directora Ejecutiva de Consultorio Jurídico de
                Servicios Integrales (despacho de abogados con más de 21 años de
                experiencia, ranqueado como uno de los mejores despachos de
                abogados de México), Conferencista especializada en Propiedad Intelectual,
                 Creadora de la marca <span class="colored">QRM – Quiero Registrar mi Marca ®</span> y
                <span class="colored">Haz que tu marca trabaje para ti, ¡Regístrala! ®</span>.
              </p>
            </div>
          </div>
        </div>
        <div
          class="row align-items-center no-gutters flex-column-reverse flex-lg-row"
        >
          <div class="col-lg-6 my-3 my-lg-0">
            <div class="info-equipo">
              <h4>Dr. Walter Omar Hernández Ortiz</h4>
              <hr class="sub-divider" />
              <h6 class="rol">Socio Fundador</h6>
              <p class="text-justify">
                Presidente de Grupo HerCar, Socio Director de Hernández
                Carreño Abogados (firma especializada en derecho corporativo y
                propiedad intelectual), Director General de Consultorio Jurídico
                de Servicios Integrales (despacho de abogados con más de 21 años
                de experiencia, ranqueado como uno de los mejores despachos de
                abogados de México). Creador de la marca <span class="colored">Toma Chocolate y Paga lo que Debes ®</span> y
                <span class="colored">Usted Venda, Nosotros Cobramos ®</span>.
              </p>
            </div>
          </div>
          <div class="col-lg-6 my-3 my-lg-0 black">
            <img
              class="img-equipo"
              :src="getImage('equipo/2000_5e33d3cd3eb25.png')"
              alt="Foto Lic. Gabriela Carreño Calva"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- MARCAS -->
    <marcas></marcas>

    <!-- Start nuestros-clientes -->

    <div>
      <h2 class="subtitle">NUESTROS CLIENTES</h2>
      <hr class="divider" />
    </div>

    <div id="pasos-after">
        <div class="container">
            <div class="row" id="nuestros-clientes-descripcion">
              <div class="col-md-12">
                <h4>Conoce cómo nuestros clientes lograron proteger sus marcas con nuestra ayuda</h4>
              </div>
            </div>

            <div class="row" id="nuestros-clientes">
                <div class="col-md-6">
                    <video :poster="getImage('testimonios-preview.png')" controls>
                        <source :src="getImage('testimonios.mp4')" type="video/mp4">
                    </video>
                </div>
                <div class="col-md-6">
                    <div class="info">
                        <div>
                            <a href="https://www.youtube.com/playlist?list=PLPNLgNfle_gp6ANELmge0G5_rIrAAsOow">
                                <svg class="youtube-main" xmlns="http://www.w3.org/2000/svg" width="52" height="52" fill="currentColor" class="bi bi-youtube" viewBox="0 0 16 16">
                                    <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z"/>
                                </svg>
                            </a>
                            <br>
                            <strong>Explora nuestras entrevistas completas</strong>
                        </div>
                    <div>

                    <strong>Síguenos para conocer más sobre nosotros</strong><br>
                    <ul class="social-links">
                        <li>
                            <a href="https://www.facebook.com/QRM-101306698367269/">
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-facebook" viewBox="0 0 16 16">
                            <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
                                </svg>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.youtube.com/playlist?list=PLPNLgNfle_gp6ANELmge0G5_rIrAAsOow">
                                <svg class="youtube-main" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-youtube" viewBox="0 0 16 16">
                                    <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z"/>
                                </svg>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.tiktok.com/@quieroregistrarmimarca">
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-tiktok" viewBox="0 0 16 16">
                                    <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z"/>
                                </svg>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <!-- End nuestros-clientes -->

    <!--PREGUNTAS FRECUENTES-->
    <preguntas-frecuentes></preguntas-frecuentes>

    <!-- CONTACTO -->
    <contacto></contacto>
  </section>
</template>

<script>
import Marcas from '@/components/Marcas.vue';
//import PreguntasFrecuentes from '@/components/PreguntasFrecuentes.vue'
import PreguntasFrecuentes from "../components/PreguntasFrecuentes";
import Contacto from '@/components/Contacto.vue'
import {contadorUsuarios} from "@/assets/js/ContadorUsuarios.js";
export default {
  name: 'LandingPage',
  components: { Marcas, PreguntasFrecuentes, Contacto, },
  methods: {
    getImage(img) {
      return require(`@/assets/img/${img}`)
    },
    scroll: function () {
      window.scroll({
      top: 0,
      behavior: 'smooth'
     });
     contadorUsuarios.actualizarDatos("SOLICITUD PASO 1");
    }
  },
}

</script>

<style scoped></style>
